import React, { useState, useEffect } from 'react';
import { compatAPI } from '../../utils/api';

export default function SinkRegistryPage() {
    const [sinks, setSinks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        compatAPI.getSinkRegistry()
            .then(res => {
                // Backend returns {data: [...]}; tolerate other shapes too.
                const d = res.data;
                const rows = Array.isArray(d) ? d
                           : Array.isArray(d?.sinks) ? d.sinks
                           : Array.isArray(d?.data)  ? d.data
                           : [];
                setSinks(rows);
            })
            .catch(err => console.error('Sink registry error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Sink Registry</h2>
            <div className="bg-white rounded-lg shadow-md p-6">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Device Name</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Manufacturer</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Protocol</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sessions</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Seen</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {sinks.map((sink, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{sink.device_name || sink.sink_name || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{sink.manufacturer || sink.sink_manufacturer || 'Unknown'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{sink.protocol || sink.sink_resolved_id || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{sink.session_count ?? sink.total_sessions ?? 0}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {sink.last_seen ? new Date(sink.last_seen).toLocaleString() : '-'}
                                    </td>
                                </tr>
                            ))}
                            {sinks.length === 0 && (
                                <tr><td colSpan="5" className="px-6 py-6 text-sm text-gray-400 text-center">No sink devices registered</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
